export default "__VITE_ASSET__C9azGSkN__"